import dev from './config.dev.json';
import prod from './config.prod.json';
import stg from './config.stg.json';

export const isDev = process.env.REACT_APP_NODE_ENV === 'development';
export const isStg = process.env.REACT_APP_NODE_ENV === 'stg';

export const config = isDev ? dev : isStg ? stg : prod;

const rawFlags = (config as any).featureFlags || {};
export const featureFlags = {
  newCheckoutUi: Boolean(rawFlags.newCheckoutUi),
  // Gates the freeze routes, entry points and status fetch; billing-manager has no flag of its own.
  subscriptionFreeze: Boolean(rawFlags.subscriptionFreeze),
  certificates: Boolean(rawFlags.certificates)
};
